import React from 'react';

import SaralLoaderImage from '../SaralLoaderImage';

const FallbackLoader: React.FC = () => {
  return (
    <div className="saral-loader">
      <SaralLoaderImage />
    </div>
  );
};

export default FallbackLoader;
